import type { TFunction } from 'i18next'

export function formatAddStudentError(errorMessage: string, t: TFunction): string {
  const lowerMessage = errorMessage.toLowerCase()
  if (lowerMessage.includes('first name and last name')) {
    return t('content.components.add_or_edit_student.duplicate_error_toast')
  }

  if (lowerMessage.includes('participation not found')) {
    return t('content.components.add_or_edit_student.participation_not_found_error_toast')
  }
  return errorMessage || t('content.components.add_or_edit_student.generic_error_toast')
}
